import { all, put, select, takeEvery } from 'redux-saga/effects';
import { parseInstrument } from 'src/lib/instrumentUtils';
import type { RootState } from 'src/store';
import type { OnTabChannelChangeEvent, ResetChannelDataAction } from 'src/store/actions/widgetAndChannel';
import { updateExecutionsInstrument } from 'src/store/actions/widgets/executions';
import { updateMessagesInstrument } from 'src/store/actions/widgets/messages';
import { updateOrdersInstrument } from 'src/store/actions/widgets/orders';
import { updatePositionsInstrument } from 'src/store/actions/widgets/positions';
import type { WidgetTabViewModel } from 'src/store/types';

function* handleResetChannelInfo(action: OnTabChannelChangeEvent | ResetChannelDataAction) {
    const currentWidget: WidgetTabViewModel = yield select((state: RootState) => state.tab.byId[action.tabId]);
    if (!currentWidget) return;

    switch (currentWidget.widget.type) {
        case 'messages': {
            yield put(updateMessagesInstrument(action.tabId, parseInstrument(''), true));
            break;
        }
        case 'positions': {
            yield put(updatePositionsInstrument(action.tabId, parseInstrument(''), true));
            break;
        }

        case 'executions': {
            yield put(updateExecutionsInstrument(action.tabId, parseInstrument(''), true));
            break;
        }
        case 'orders': {
            yield put(updateOrdersInstrument(action.tabId, parseInstrument(''), true));
            break;
        }
    }
}

export function* resetLinkingSagas() {
    yield all([takeEvery(['onTabChannelChange', 'resetChannelData'], handleResetChannelInfo)]);
}
